import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { label, message } from '../../utilities/resources';
import ConsignorAPI from '../../api/ConsignorAPI';
import ConsignorGroupAPI from '../../api/ConsignorGroupAPI';
import Utilities from '../../utilities/utilities';
import { addConsignorList, addConsignorGroup, setConsignor } from '../../actions/consignorHome.action';
import ConsignorHomeLoading from './ConsignorHomeLoading';
import ServerError from '../ServerError';
import LoadingEffect from '../commons/LoadingEffect';

class ConsignorHome extends Component {
  static renderConsignorList(consignorList) {
    const result = [];
    if (consignorList && consignorList.length) {
      consignorList.forEach((consignor) => {
        result.push(
          <option key={consignor.consignorID.trim()} value={consignor.consignorID.trim()}>
            {`${consignor.name} (${consignor.consignorID})`}
          </option>
        );
      });
    }

    return result;
  }

  static renderConsignorGroup(consignorGroups) {
    const result = [];

    if (consignorGroups && consignorGroups.length) {
      consignorGroups.forEach((consignorGroup) => {
        result.push(
          <option key={consignorGroup.groupID} value={consignorGroup.groupID}>
            {consignorGroup.description}
          </option>
        );
      });
    }
    return result;
  }

  static splitSpaceInObject(data) {
    const item = { ...data };
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'string') {
        if (data[key] !== undefined && data[key] !== null) {
          item[key] = data[key].trim();
        }
      }
    });
    return item;
  }

  STATUS_CONSIGNOR_ID_HAS_EXISTED = 400;

  constructor(props) {
    super(props);
    this.state = {
      consignorID: '',
      isDefaultLoading: true,
      isError: false,
      isNewConsignor: true,
      isSaveLoading: false,
      messageText: '',
      messageCss: ''
    };

    this.handleSelectConsignor = this.handleSelectConsignor.bind(this);
    this.handleSubmitLookup = this.handleSubmitLookup.bind(this);
    this.getDataFromAPI = this.getDataFromAPI.bind(this);
    this.handleSubmitNew = this.handleSubmitNew.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.handleSaveChanges = this.handleSaveChanges.bind(this);
    this.changeMessage = this.changeMessage.bind(this);
    this.changeStateLoading = this.changeStateLoading.bind(this);
    this.resetConsignorDetail = this.resetConsignorDetail.bind(this);
    this.messageError = 'message-error';
    this.messageSuccess = 'message-success';
  }

  componentDidMount() {
    this.resetConsignorDetail();
    this.getDataFromAPI();
  }

  handleSelectConsignor(event) {
    this.setState({
      consignorID: event.target.value
    });
  }

  handleSubmitLookup(event) {
    const { consignorID } = this.state;
    const { setConsignorDetail } = this.props;
    this.changeMessage('', this.messageError);
    if (!Utilities.isEmpty(consignorID.trim())) {
      this.changeStateLoading(true);
      ConsignorAPI.getConsignor(consignorID.trim())
        .then((data) => {
          this.setState({
            isError: false
          });
          setConsignorDetail(ConsignorHome.splitSpaceInObject(data));
          this.setState({ isNewConsignor: false, isDefaultLoading: false, isSaveLoading: false });
        })
        .catch((error) => {
          if (Utilities.isUnauthorizedRequest(error)) return;
          this.setState({
            isError: true
          });
          setConsignorDetail({});
          this.changeMessage(`${message.UnableToLocateConsignor} ${consignorID}`, this.messageError);
        });
    } else {
      this.changeMessage(message.ConsingorIDEmpty, this.messageError);
    }
    event.preventDefault();
  }

  handleSubmitNew(event) {
    this.resetConsignorDetail();
    this.setState({
      isNewConsignor: true,
      consignorID: '',
      isDefaultLoading: false,
      isError: false,
      isSaveLoading: false,
      messageText: '',
      messageCss: ''
    });
    event.preventDefault();
  }

  handleChangeValue(fieldName, value) {
    let updateValue = value;
    if (fieldName === 'consignorID' && !Utilities.isEmpty(value)) {
      updateValue = value.toUpperCase().trim();
    }
    const { consignor } = this.props;
    const { setConsignorDetail } = this.props;
    const cloneConsignor = { ...consignor };
    cloneConsignor[fieldName] = updateValue;
    setConsignorDetail(cloneConsignor);
  }

  async handleSaveChanges() {
    const { consignor, setConsignorDetail } = this.props;
    const { isNewConsignor } = this.state;
    if (!Utilities.isEmpty(consignor.consignorID)) {
      this.setState({
        isSaveLoading: true
      });
      ConsignorAPI.saveConsignor(consignor, isNewConsignor)
        .then((data) => {
          this.getDataFromAPI();
          setConsignorDetail(data);
          this.setState({
            consignorID: data.consignorID,
            isNewConsignor: false,
            isSaveLoading: false,
            messageText: `${message.SuccessfullyUpdated} ${data.consignorID}`,
            messageCss: this.messageSuccess,
            isError: false
          });
        })
        .catch((error) => {
          if (Utilities.isUnauthorizedRequest(error)) return;
          let errorCode;
          const { response } = error;
          if (!Utilities.isEmpty(response)) {
            const { status } = response;
            errorCode = status;
          }
          if (errorCode && errorCode === this.STATUS_CONSIGNOR_ID_HAS_EXISTED) {
            // consignor id has existed
            setConsignorDetail(consignor);
            this.setState({
              isSaveLoading: false,
              messageText: message.ConsingorIDHasExisted,
              messageCss: this.messageError,
              isError: false
            });
          } else {
            setConsignorDetail(consignor);
            this.setState({
              isSaveLoading: false,
              isError: true
            });
          }
        });
    } else {
      this.changeMessage(message.ConsingorIDEmpty, this.messageError);
    }
  }

  async getDataFromAPI() {
    const { setConsignorList, setConsignorGroup } = this.props;
    try {
      const consignorList = await ConsignorAPI.getConsignors();
      const consignorGroup = await ConsignorGroupAPI.getConsignorGroups();

      if (consignorList && consignorGroup && typeof consignorList !== 'string' && typeof consignorGroup !== 'string') {
        setConsignorList(consignorList);
        setConsignorGroup(consignorGroup);
        this.setState({
          isDefaultLoading: false,
          isError: false
        });
      } else {
        this.setState({
          isError: true
        });
      }
    } catch (error) {
      if (Utilities.isUnauthorizedRequest(error)) return;
      this.setState({
        isError: true
      });
    }
  }

  changeMessage(newMessage, newCss) {
    this.setState({
      messageText: newMessage,
      messageCss: newCss
    });
  }

  changeStateLoading(stateLoading) {
    this.setState({
      isDefaultLoading: stateLoading
    });
  }

  resetConsignorDetail() {
    const { setConsignorDetail } = this.props;
    const newConsignor = {
      isActive: '',
      consignorID: '',
      groupID: '',
      name: '',
      parentID: '',
      isPublic: 'N'
    };
    setConsignorDetail(newConsignor);
  }

  render() {
    const { consignorID, isDefaultLoading, isError, isNewConsignor, messageText, messageCss, isSaveLoading } =
      this.state;
    const { consignorList, consignorGroup, consignor } = this.props;

    if (isError) {
      return <ServerError />;
    }
    if (isDefaultLoading) {
      return <ConsignorHomeLoading />;
    }
    return (
      <div className="mui" id="pageFrame">
        <div id="pageBody">
          <div id="contentWrapper">
            {/* main content - start */}
            <table border="0" cellPadding="0" cellSpacing="5" aria-label="Consignor form">
              <tbody>
                <tr>
                  <td aria-hidden="true">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right">
                    <b>{label.Consignor}</b>
                  </td>
                  <td>
                    <form acceptCharset="UTF-8" onSubmit={this.handleSubmitLookup} className="width-form">
                      <select
                        name="consignor"
                        onChange={this.handleSelectConsignor}
                        value={consignorID}
                        aria-label={label.Consignor}
                      >
                        <option value="">{label.AddNewConsignor}</option>
                        {ConsignorHome.renderConsignorList(consignorList)}
                      </select>
                      &nbsp;&nbsp;
                      <input name="lookup" type="submit" value={label.Lookup} aria-label={label.Lookup} />
                    </form>
                  </td>
                  <td>
                    <form acceptCharset="UTF-8" onSubmit={this.handleSubmitNew}>
                      {isSaveLoading ? (
                        <LoadingEffect width="width-new-saveChanges" height="height-loading" />
                      ) : (
                        <input id="new" name="new" type="submit" value={label.New} aria-label={label.New} />
                      )}
                    </form>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <b className={`${messageCss}`}>{messageText}</b>
                  </td>
                </tr>
                <tr>
                  <td align="right">
                    <b>{label.ConsignorID}</b>
                  </td>
                  <td>
                    <input
                      id="consignor"
                      maxLength="10"
                      name="consignor"
                      size="10"
                      type="text"
                      onChange={(event) => this.handleChangeValue('consignorID', event.target.value)}
                      value={Utilities.isEmpty(consignor.consignorID) ? '' : consignor.consignorID.trim()}
                      disabled={!isNewConsignor}
                      aria-label={label.ConsignorID}
                    />
                  </td>
                </tr>
                <tr>
                  <td align="right">
                    <b>{label.Group}</b>
                  </td>
                  <td>
                    <select
                      id="groupid"
                      name="groupid"
                      value={consignor.groupID}
                      onChange={(event) => this.handleChangeValue('groupID', event.target.value)}
                      aria-label={label.Group}
                    >
                      <option value="">{label.None}</option>
                      {ConsignorHome.renderConsignorGroup(consignorGroup)}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td align="right">
                    <b>{label.Name}</b>
                  </td>
                  <td>
                    <input
                      id="name"
                      maxLength="255"
                      name="name"
                      size="25"
                      type="text"
                      onChange={(event) => this.handleChangeValue('name', event.target.value)}
                      value={Utilities.isEmpty(consignor.name) ? '' : consignor.name}
                      aria-label={label.Name}
                    />
                  </td>
                </tr>
                <tr>
                  <td align="right">
                    <b>{label.Active}</b>
                  </td>
                  <td>
                    <input
                      id="is_active_X"
                      name="is_active"
                      type="radio"
                      value="X"
                      checked={consignor.isActive === 'X'}
                      onChange={(event) => this.handleChangeValue('isActive', event.target.value)}
                      aria-label={`${label.Active} ${label.Yes}`}
                    />
                    {`${label.Yes}      `}
                    <input
                      id="is_active_"
                      name="is_active"
                      type="radio"
                      value=""
                      checked={consignor.isActive !== 'X'}
                      onChange={(event) => this.handleChangeValue('isActive', event.target.value)}
                      aria-label={`${label.Active} ${label.No}`}
                    />
                    {`${label.No}    `}
                  </td>
                </tr>
                <tr>
                  <td align="right">
                    <b>{label.Public}</b>
                  </td>
                  <td>
                    <input
                      id="is_public_Y"
                      name="is_public"
                      type="radio"
                      value="Y"
                      checked={consignor.isPublic === 'Y'}
                      onChange={(event) => this.handleChangeValue('isPublic', event.target.value)}
                      aria-label={`${label.Public} ${label.Yes}`}
                    />
                    {`${label.Yes}      `}
                    <input
                      id="is_public_"
                      name="is_public"
                      type="radio"
                      value="N"
                      checked={consignor.isPublic !== 'Y'}
                      onChange={(event) => this.handleChangeValue('isPublic', event.target.value)}
                      aria-label={`${label.Public} ${label.No}`}
                    />
                    {`${label.No}    `}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" aria-hidden="true">
                    &nbsp;
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    <i className="fa fa-spinner fa-spin" />
                    {isSaveLoading ? (
                      <LoadingEffect width="width-saveChanges" height="height-loading" />
                    ) : (
                      <input
                        name="save"
                        id="save"
                        onClick={(event) => this.handleSaveChanges(event)}
                        type="submit"
                        value={label.SaveChanges}
                        aria-label={label.SaveChanges}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* main content - end */}
          </div>
        </div>
      </div>
    );
  }
}

ConsignorHome.propTypes = {
  setConsignorList: PropTypes.func,
  setConsignorGroup: PropTypes.func,
  setConsignorDetail: PropTypes.func,
  consignorList: PropTypes.array,
  consignorGroup: PropTypes.array,
  consignor: PropTypes.object
};

ConsignorHome.defaultProps = {
  setConsignorList: null,
  setConsignorGroup: null,
  setConsignorDetail: null,
  consignorList: [],
  consignorGroup: [],
  consignor: {}
};

const mapDispatchToProps = (dispatch) => ({
  setConsignorList: (consignorList) => {
    dispatch(addConsignorList(consignorList));
  },
  setConsignorGroup: (consignorGroup) => {
    dispatch(addConsignorGroup(consignorGroup));
  },

  setConsignorDetail: (consignor) => {
    dispatch(setConsignor(consignor));
  }
});

const mapStateToProps = (state) => {
  return {
    consignorList: state.consignorHome.consignorList,
    consignorGroup: state.consignorHome.consignorGroup,
    consignor: state.consignorHome.consignor
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsignorHome);
